import { useState } from "react";

import { deleteListingSearch } from "../service";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

const DeleteSearchModal = ({ show, searchId, onDelete, userId }) => {
  const [deleting, setDeleting] = useState(false);

  const deleteSearch = async () => {
    setDeleting(true);
    await deleteListingSearch(userId, searchId);
    setDeleting(false);
    onDelete(true);
  };

  return (
    <Modal
      id="delete-search-modal"
      show={show}
      onHide={onDelete}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[400px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Delete Saved Search" />

      <Modal.Body>Are you sure you want to delete this search? This action cannot be undone.</Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={onDelete}>
          Cancel
        </Button>
        <Button size="medium" schema="warning" onClick={deleteSearch} isLoading={deleting}>
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSearchModal;
